import React from 'react';

const ChevronDown = ({style=null}) => (
  <svg
    aria-label="chevron down icon"
    className="icon icon-chevron-down"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13 6"
    style={style}
  >
    <path
      d="M6.72 3.666L1.857.822a.758.758 0 00-.758 1.312l5.204 3.044a.754.754 0 00.417.1.754.754 0 00.417-.1l5.204-3.044a.758.758 0 00-.758-1.312L6.72 3.666z"
      fill="currentColor"
      fillRule="evenodd"
    ></path>
  </svg>
);

export default ChevronDown;
